<template>
  <div id="commissionResults" v-show="showTable">
  <!-- <div id="commissionResults" > -->
    <template>


        <div class="d-flex align-items-center justify-content-between">

          <!-- <h4><span v-html="item.commission_form.title"></span></h4> -->

<!--             <download-excel
              class="btn btn-default"
              :data="item.commission_groups"
              :exportFields="fields[i]"
              worksheet="Commission Results"
              :name="item.commission_form.title + '.csv'"
              :footer="excelTermsOfUse"
          >
            <b-button>Download .csv</b-button>
          </download-excel> -->

        </div>
        <div id="table-wrapper" class="my-5">
        </div>

    </template>
  </div>
</template>

<script>
import {bus} from "@/event-bus"
import HelperFunctions from "@/mixins/helper-functions"
export default {
  name: "commissionResults",
  mixins: [HelperFunctions],
  data: () => ({
    showTable: false,
    foundGroups: false,
    foundProducts: false,
    commissionResultItems: [],
    fields: [
        {
            key: 'carrier',
            label: 'Carrier',
            sortable: true,
            tdClass: 'w-50',
        },
        {
            key: 'commissions_group',
            label: 'Commissions Group',
            sortable: true,
            tdClass: 'no-wrap text-nowrap',
        },
        {
            key: 'product',
            label: 'Product',
            sortable: true,
            tdClass: 'no-wrap text-nowrap',
        },
    ],
    agencyName: '',
    groupName: '',
  }),
  mounted() {
    bus.$on("update-commission-results-items", items => {
      this.commissionResultItems = []
      this.commissionResultItems = items

      const tableWrapper = document.getElementById('table-wrapper');
      while (tableWrapper.firstChild) {
        tableWrapper.removeChild(tableWrapper.firstChild);
      }
      let rowIndex = 0;

      if (items.length == 0) {
        this.showTable = false;
        return;
      }
      this.showTable = true;

      items.forEach(carrier => {
        const titleDiv = document.createElement('div');
        titleDiv.classList.add("d-flex", "justify-content-between", "align-items-center");

        const carrierTitle = document.createElement('h2');
        carrierTitle.textContent = carrier.carrier_name;
        titleDiv.appendChild(carrierTitle);

        if (carrier.schedule_url != "") {
          const urlButton = document.createElement('button');
          urlButton.textContent = "View Carrier Schedules";
          urlButton.classList.add("btn", "btn-primary", "btn-url");
          urlButton.onclick = function() {
            window.open(carrier.schedule_url, '_blank');
          };
          titleDiv.appendChild(urlButton);
        }

        tableWrapper.appendChild(titleDiv);

        carrier.commission_groups.forEach(group => {
          let table = this.createTable(group);
          tableWrapper.appendChild(table);
        });
      });
    })

    bus.$on("update-carriers", carriers => {
      this.carriers = []
      this.carriers = carriers
    })
  },
  methods: {

    createTable(group) {
      let table = document.createElement('table');
      table.border = "1";

      let thead = document.createElement('thead');
      let headerRow = document.createElement('tr');
      let levels = group.acf.levels
      let streetLevel = group.acf.levels.length-1
      while (levels.length < 10) {
        levels.push({level_name: "", level_notes: ""});
      }
      const headers = [group.acf.commissions_group_name, 'Min Age', 'Max Age', levels[0].level_name, levels[1].level_name, levels[2].level_name, levels[3].level_name, levels[4].level_name, levels[5].level_name, levels[6].level_name, levels[7].level_name, levels[8].level_name, levels[9].level_name,  'Bonus Product', 'Effective Date', 'Last Updated'];

      headers.forEach((headerText, index) => {
        let th = document.createElement("th");
        th.appendChild(document.createTextNode(headerText));
        if (index === 0) {
          th.classList.add("column-name");
        } else if (index === 1 || index === 2) {
          th.classList.add("column-small");
        } else {
          th.classList.add("column-normal");
        }

        if (index === headers.length - 1) {
          th.classList.add("column-last");
        }

        headerRow.appendChild(th);
      });

      headerRow.classList.add("commission-search-header");

      let headerStreetLevelCell = headerRow.childNodes[3+streetLevel];
      headerStreetLevelCell.classList.add("street-level");

      thead.appendChild(headerRow);
      table.appendChild(thead);

      let tbody = document.createElement('tbody');
      let lastProductRowIndex = 0;

      group.products.forEach((product, index) => {
          let row = document.createElement('tr');
          row.classList.add(index % 2 === 0 ? 'row-even' : 'row-odd');

          let applicableRates = product.acf.applicable_rates
          while (applicableRates.length < 10) {
            applicableRates.push({level_name: "", level_notes: "", rate:""});
          }
          product.acf.applicable_rates = applicableRates

          let bonusProduct = "No";
          if (product.acf.bonus_product)  {
            bonusProduct = "Yes"
          }

          const month  = product.acf.effective_date.substring(0,2);
          const day    = product.acf.effective_date.substring(3,5);
          const year   = product.acf.effective_date.substring(6,10);
          const convertedDate = year + "-" + month + "-" + day;

          row = this.createCell(row, product.acf.product_name, "name column-name")
          row = this.createCell(row, product.acf.minimum_age, "min_age column-small")
          row = this.createCell(row, product.acf.maximum_age, "max_age column-small")
          row = this.createCell(row, applicableRates[0].rate, "rate_0 column-normal");
          row = this.createCell(row, applicableRates[1].rate, "rate_1 column-normal");
          row = this.createCell(row, applicableRates[2].rate, "rate_2 column-normal");
          row = this.createCell(row, applicableRates[3].rate, "rate_3 column-normal");
          row = this.createCell(row, applicableRates[4].rate, "rate_4 column-normal");
          row = this.createCell(row, applicableRates[5].rate, "rate_5 column-normal");
          row = this.createCell(row, applicableRates[6].rate, "rate_6 column-normal");
          row = this.createCell(row, applicableRates[7].rate, "rate_7 column-normal");
          row = this.createCell(row, applicableRates[8].rate, "rate_8 column-normal");
          row = this.createCell(row, applicableRates[9].rate, "rate_9 column-normal");
          row = this.createCell(row, bonusProduct, "bonus column-normal");
          row = this.createCell(row, convertedDate, "eff_date column-normal");
          row = this.createCell(row, product.last_updated, "updated column-normal");

          let levelCell = row.querySelector("rate_" + streetLevel);
          let rowStreetLevelCell = row.childNodes[3+streetLevel];
          rowStreetLevelCell.classList.add("street-level");

          tbody.appendChild(row);
          lastProductRowIndex = index;
      });

      let levelNotesRow = document.createElement('tr');
      let isEven = (lastProductRowIndex + 1) % 2 === 0;
      levelNotesRow.classList.add(isEven ? 'row-even' : 'row-odd', 'notes-row');

      levelNotesRow = this.createCell(levelNotesRow, "Notes", "name-notes column-name")
      levelNotesRow = this.createCell(levelNotesRow, "", "min_age-notes column-small")
      levelNotesRow = this.createCell(levelNotesRow, "", "max_age-notes column-small")
      levelNotesRow = this.createCell(levelNotesRow, levels[0].level_notes, "rate_0-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[1].level_notes, "rate_1-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[2].level_notes, "rate_2-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[3].level_notes, "rate_3-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[4].level_notes, "rate_4-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[5].level_notes, "rate_5-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[6].level_notes, "rate_6-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[7].level_notes, "rate_7-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[8].level_notes, "rate_8-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, levels[9].level_notes, "rate_9-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, "", "bonus-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, "", "eff_date-notes column-normal")
      levelNotesRow = this.createCell(levelNotesRow, "", "updated-notes column-normal")

      levelNotesRow.classList.add("notes-row");
      tbody.appendChild(levelNotesRow);

      let groupNotesRow = document.createElement('tr');
      let groupNotesCell = document.createElement('td');
      let groupNotesText = document.createElement('div');
      groupNotesText.innerHTML = "Commission Group Notes: " + group.acf.group_notes;
      groupNotesCell.appendChild(groupNotesText);
      groupNotesCell.colSpan = 17;
      groupNotesRow.appendChild(groupNotesCell);
      groupNotesRow.classList.add("group-notes");

      tbody.appendChild(groupNotesRow);

      table.appendChild(tbody);

      return table
    },

    createCell(row, value, classnames) {
      let cell = document.createElement('td');
      if (typeof value == "undefined") {
        value = "";
      }
      cell.appendChild(document.createTextNode(value));
      classnames.split(' ').forEach(classname => cell.classList.add(classname));
      row.appendChild(cell);
      return row;
    },

    stripHTMLTags(str) {
      return str.replace(/<[^>]*>/g, '');
    },

    formatDate(date) {
      const month  = date.substring(0,2);
      const day    = date.substring(3,5);
      const year   = date.substring(6,10);
      const convertedDate = year + "-" + month + "-" + day;
      return convertedDate;
    },

  },
  computed: {
  },
}
</script>

<style>

#content {
  background-color: white;
}

#commissionResults .commission-search-header {
  background-color: #0076BD;
  position: sticky;
  top: 0;
  z-index: 9999;
}

#commissionResults .commission-search-header th {
  padding: 8px;
  text-align: center;
  vertical-align: bottom;
}

#commissionResults table {
  border-color: #6E6F71;
  border-width: 1px;
  border-bottom-color: #6E6F71;
  border-bottom-width: 1px;
  border-top-color: #6E6F71;
  border-top-width: 2px;
  border-collapse: separate;
  border-spacing: 0;
}

#commissionResults th {
  color: white;
  border-right-color: white;
  border-right-width: 1px;
  border-left-color: white;
  border-left-width: 1px;
  border-bottom-color: #6E6F71;
  border-bottom-width: 0px;
  border-top-color: #6E6F71;
  border-top-width: 0px;
}

#commissionResults th.column-name {
  border-left-color: #6E6F71;
  border-left-width: 1px;
}

#commissionResults th.column-last {
  border-right-color: #6E6F71;
  border-right-width: 1px;
}

#commissionResults th.street-level {
  background-color: #004472;
}

#commissionResults td {
  border-width: 1px;
  border-color: #6E6F71;
}

#commissionResults table > tbody > tr:first-child > td {
    border-top-width: 2px;
}

#commissionResults td.street-level {
  color: #004472;
  font-weight: 500;
}

#commissionResults .column-name {
  width: calc(2 * 100% / 17);
  text-align: left;
}

#commissionResults .column-small {
  width: calc(0.5 * 100% / 17);
}

#commissionResults .column-normal {
  width: calc(100% / 17);
}

#commissionResults .notes-row tr,
#commissionResults .notes-row td,
#commissionResults .group-notes tr,
#commissionResults .group-notes td, {
  background-color: aliceblue;
  font-style: italic;
}

#commissionResults td {
  text-align: center;
}

#commissionResults td.name {
  text-align: start;
}

#commissionResults tr.row-even {
  background-color: white;
}

#commissionResults tr.row-odd {
  background-color: #E7E7E7;
}

#commissionResults td.rate_0,
#commissionResults td.rate_1,
#commissionResults td.rate_2,
#commissionResults td.rate_3,
#commissionResults td.rate_4,
#commissionResults td.rate_5,
#commissionResults td.rate_6,
#commissionResults td.rate_7,
#commissionResults td.rate_8,
#commissionResults td.rate_9 {
  text-align: end;
}

#commissionResults .group-notes tr {
  border-width: 0px 1px 0px 0px;
}

#commissionResults .group-notes td {
  border-width: 3px 2px 3px 2px;
  border-color: #6E6F71;
  text-align: start;
}

#commissionResults button.btn-primary.btn-url {
  background-color: #091b59;
  border-color: #091b59;
}
</style>
